"use client";

import type { BlogAuthor } from "@/models/news";
import Head from "next/head";
import AuthorCard from "../../components/author/AuthorCard";
import useAxiosQuery from "@/hooks/useMyQuery";

const AuthorPage = () => {
  const { data: authorData, isLoading: isLoadingAuthor } = useAxiosQuery<{ data: BlogAuthor[] }>({
    url: `/v1/blog/vi/author`,
    method: "get",
  });

  return (
    <>
      <Head>
        <title>{"Klarda Blog"}</title>
      </Head>
      <main className="min-h-screen py-24 px-10 text-center mt-[10px]">
        <h1 className="text-4xl font-bold text-gray-900">DANH SÁCH TÁC GIẢ</h1>
        <h5 className="text-xl text-gray-500 mt-4">Khám phá các tác giả phổ biến nhất trên Klarda</h5>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mt-16">
          {authorData?.data?.map((author, i) => (
            <div className="col-span-1 lg:col-span-3" key={author?.user_id?.id || "" + i}>
              <AuthorCard data={author} />
            </div>
          ))}
        </div>
      </main>
    </>
  );
};

export default AuthorPage;

